import React from "react";
import { EventTypes } from "sweet-global";
import Filter from "./Filter";

const EventTypesTitle = {};
EventTypes.forEach(
  eventType => (EventTypesTitle[eventType.name] = eventType.title)
);

export default props => (
  <Filter
    width={120}
    name="eventType"
    title="Event Type"
    type="select"
    label={value => EventTypesTitle[value]}
    {...props}
  />
);
